import { cn } from "@/lib/utils";
import { LoaderCircle } from "lucide-react";
import LogoIcon from "@/assets/myth-icon.svg?react";

export function Loading({
  noLogo,
  noSpinner,
  className,
}: {
  noLogo?: boolean;
  noSpinner?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col gap-4 justify-center items-center relative",
        className
      )}
    >
      {noLogo ? null : (
        <>
          <div className="text-xl flex gap-1 justify-center relative">
            <LogoIcon className="block text-foreground/70" style={{ width: 96, height: 96 }} />
            <div style={{backgroundSize: "153px 153px"}} className="absolute bg-no-repeat rounded-[100%] -inset-[15px] bg-gradient-to-r from-background/70 via-transparent to-background/70 animate-spin2">
              
            </div>
          </div>
          {/* <div className="inline-block text-primary animate-bounce">.</div> */}
        </>
      )}
      { noSpinner ? null : <LoaderCircle className="animate-spin" /> }
    </div>
  );
}
